import { axios } from '@Utils'

const getRegistrationStatus = async (draftMembershipId: string) =>
  axios.get(`/bff/app/registration/${draftMembershipId}/status`, {
    headers: {
      'x-api-version': 2,
    },
  })

const saveRegistrationDocument = async (
  draftMembershipId: string,
  formData: FormData
) =>
  axios.post(
    `/bff/registration/${draftMembershipId}/business-document`,
    formData
  )

export { getRegistrationStatus, saveRegistrationDocument }
